











import {Vue, Component, Watch, Prop, Emit} from 'vue-property-decorator'
import 'pc-bootstrap4-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from "moment";

@Component({})
export default class name extends Vue {
    $datetimepicker;

    @Prop() value!: Date;
    @Prop({default: false}) invalidDate!: boolean;
    @Prop() hideIcon!: boolean;

    @Watch('value') onValueChanged(value) {
        this.$datetimepicker.datetimepicker('date', value || null);
    }

    mounted() {
        this.$datetimepicker = $(this.getReference()).datetimepicker({
            format: 'HH:mm',
            date: this.value
        });
        this.$datetimepicker.on('dp.change', e => {
            const d = moment(e.date);
            this.input(d.isValid() ? d.toDate() : null);
        });
    }

    open() {
        this.$datetimepicker.datetimepicker('show');
    }

    getReference() {
        return <HTMLElement>this.$refs['datetimepicker'];
    }

    @Emit() input(value) {}

    destroyed() {
        this.$datetimepicker.datetimepicker('destroy');
    }

}
